import { fetchAPI } from "@/api/api"
import { fingerprintProPublicKeyDataSchema } from "@/schemas/account"
import type { FingerprintProPublicKeyData } from "@/types/account"
import { z } from "zod/v4"

const FINGERPRINT_PRO_PUBLIC_KEY_API_URL =
  "/exchange/member/playerService/getFingerprintProPublicKey"

// getFingerprintProPublicKey (PlayerController) reads no parameters
const getFingerprintProPublicKeyRequestSchema = z.strictObject({})

const fetch = {
  url: FINGERPRINT_PRO_PUBLIC_KEY_API_URL,
  handler: async (): Promise<FingerprintProPublicKeyData | undefined> => {
    const res = await fetchAPI({
      url: FINGERPRINT_PRO_PUBLIC_KEY_API_URL,
      method: "get",
      // { status: "9999", status_msg } when Fingerprint Pro is off for the site or the lookup fails
      requestSchema: getFingerprintProPublicKeyRequestSchema,
      schema: fingerprintProPublicKeyDataSchema.or(
        z.object({ status: z.string(), status_msg: z.string() })
      )
    })

    if (!("publicKey" in res) || res.status_msg !== "Success") {
      console.warn("[getFingerprintProPublicKey] API returned non-success status", res)
      return undefined
    }

    return res
  }
}

export default fetch
